import { AboveBelowFieldsContentType } from 'common.types'
import Accordion from 'components/Accordion/Accordion'
import { useDynamicFormContent } from 'hooks'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const MailInBallotAboveFieldsContent: React.FC<
  AboveBelowFieldsContentType
> = ({ step }) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: `mailInBallotForm.aboveFieldsContent`,
  })

  const { formContent } = useDynamicFormContent()
  const dates = formContent?.dates
  return (
    <>
      {step === 1 && (
        <div
          dangerouslySetInnerHTML={{
            __html: t(`disclosureOne.label`, {
              electionDay: dates?.electionDay,
              mailInBallotDeadline: dates?.mailInBallotDeadline,
            }),
          }}
        ></div>
      )}
    </>
  )
}
